import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';

/* current module imports */
import { AccountRoutingModule } from './account-routing.module';
import { ProfileComponent } from './components/profile/profile.component';
import { AccountIconComponent } from './components/account-icon/account-icon.component';

@NgModule({
  declarations: [
    ProfileComponent,
    AccountIconComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    SharedModule,
    FormsModule,
    AccountRoutingModule,
  ],
  exports: [
    AccountIconComponent,
  ],
})
export class AccountModule { }
